<template>
  <div class="special-component">
    <div class="pg">
      <q-icon name="fas fa-ban" size="60px" color="negative"></q-icon>
    </div>
    <div>Sorry you do not have any {{name}}.</div>
    <div>
      {{description}}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    name: String,
    description:String
  }
};
</script>